import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { StaffAction } from '../../../actions/staff.action';
import { StaffDetailPage } from '../detail/staff-detail'; 
import { StaffEditPage } from '../edit/staff-edit'; 
import { AbstractPage } from '../../_com/abstract-page';

/**
 * Generated class for the StaffListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-staff-list',
  templateUrl: 'staff-list.html',
})
export class StaffListPage extends AbstractPage{

	data = [];

  constructor(
  	public navCtrl: NavController, 
  	public navParams: NavParams,
  	public staffAction:StaffAction,
  	) {
    super();
  }

  ionViewDidEnter() {
    this.refresh();
  }

  /**
   * 一覧リフレッシュ
   */
  refresh(){
  	this.staffAction.getList({}).subscribe((data)=>{
  		this.data = data.data;
  	})
  }

  /**
   * 詳細画面へ
   */
  goDetail(staff){
  	this.navCtrl.push(StaffDetailPage, staff);
  }

  /**
   * 新規スタッフ追加
   */
  addStaff(){

    this.navCtrl.push(StaffEditPage);

    // var self = this;
    // let modal = this.modalController.create(StaffEditPage, {});
    // modal.present();
    // modal.onDidDismiss((data)=>{
    //   if(data["update"]){
    //     self.refresh();
    //   }
    // });
  }
}



// WEBPACK FOOTER //
// ./src/pages/staff/list/staff-list.ts